import { useTapState } from "@/hooks/useTapState";
import { Gesture, GestureDetector } from "react-native-gesture-handler";

export default ({children}) => {
    
    const setTapState = useTapState((state) => state.setTapState);
    
    const isActive = useTapState((state) => state.active);
    
    const tap = Gesture.Tap().runOnJS(true).onBegin((e) => {
        if (isActive && e?.pointerType <= 2) {
            setTapState({x: e.x, y: e.y});
        }
    });
    
    return <GestureDetector gesture={tap}><>{children}</></GestureDetector>
}